import React, {useState, useRef, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import {InputText} from 'primereact/inputtext';
import {Password} from 'primereact/password';
import {Button} from 'primereact/button';
import {Card} from 'primereact/card';
import {Message} from 'primereact/message';
import { Dialog } from "primereact/dialog";
import axios from "axios";
import { setBaseUrl } from "../services/envhttp";
import '../assets/css/login.css'

const LoginPage = () => {

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [userId, setUserId] = useState(null);
    const [error, setError] = useState('');
    const [errorDialogVisible, setErrorDialogVisible] = useState(false);
    const [apiErrorDialog, setApiErrorDialog] = useState(sessionStorage.getItem("taxSessionExpired") === "true");
    const [errorMessage, setErrorMessage] = useState('');
    const [errorHeader, setErrorHeader] = useState('API Error');
    const navigate = useNavigate();
    const radixTestUrl = process.env.REACT_APP_TAX_URL;
    const envBaseUrl = process.env.REACT_APP_TAX_APP_URL || '';
    const isProdDb = /radixappsdb/i.test(envBaseUrl);
    const loginEndpoint = isProdDb
      ? `${radixTestUrl}/api/login/getValidatePasswordProd`
      : `${radixTestUrl}/api/login/getValidatePassword`;

    useEffect(() => {
      const userId = localStorage.getItem("taxUserId");
      const token = localStorage.getItem("taxToken");
      const expiryTime = localStorage.getItem("taxExpiryTime");
      // const taxRestUrl = localStorage.getItem("taxRestUrl");
      const currentTime =  new Date().getTime();
    

      if(userId && token && expiryTime && currentTime < Number(expiryTime)){
        navigate("/Pages/Clients")
      }
    }, [navigate])

    const handleLogin = async (e) => {

    e.preventDefault();

    const p_param = {
    "p_user_name": username,
    "p_password": password,
    "p_app_code": "TAX"
        }
      try {
        const response = await axios.post(loginEndpoint, p_param);
        if (response.data.length > 0) {
          let successFlag = response.data[0];
          if (successFlag === "Y") {
            localStorage.removeItem("taxSelectedClientId");
            localStorage.removeItem("taxSelectedClientName");
            localStorage.removeItem("taxSelectedTaxYear");
            window.dispatchEvent(new Event("taxSelectionChanged"));
            setUserId(response.data[1]);
            localStorage.setItem("taxUserId", response.data[1]);
            localStorage.setItem("taxToken", response.data[2]);
            localStorage.setItem("taxFirmId", response.data[7]);
            localStorage.setItem("taxExpiryTime", response.data[4]);
            // localStorage.setItem("taxRestUrl", response.data[5]);
            // setBaseUrl(response.data[5]);
            navigate("/Pages/Clients")
          } else {
            //setRows(null);
            setUserId(null);
            setErrorHeader('Validation Failed');
            const errorInfo = response.data[6];
            setErrorMessage(errorInfo);
            setErrorDialogVisible(true);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setUserId(null);
          const errorInfo = response.data[6];
          // Set the error message and display the dialog
          setErrorMessage(errorInfo);
          setErrorDialogVisible(true);
        }

        //setRows(response.data);
      } catch (error) {
          // Set the error message and display the dialog
            setErrorMessage(error.message);
            setErrorDialogVisible(true);
      } finally {
        sessionStorage.setItem("taxSessionExpired", "false");
      }
    };

  const hideDialog = () => {
    setErrorDialogVisible(false);
  };

return(
    <div className="login-wrapper">
        <Card title="Login" className="login-card">
            <form onSubmit={handleLogin} autoComplete="on" method="POST">
            <div className="field">
                <label htmlFor="username">Username</label>
                <InputText id="username" name="username" type="text" value={username} autoComplete="username" onChange={(e) => setUsername(e.target.value)}
                className="w-full"/>
            </div>
            <div className="field">
                <label htmlFor="password">Password</label>
                <Password id="password" name="password" value={password} onChange={(e) => setPassword(e.target.value)}
                toggleMask feedback={false} autoComplete="current-password" inputStyle={{width: "19.5rem"}} className="w-full"/>
            </div>
            {error && <Message severity="error" text={error} className="mb-3"/>}
            <Button label="Login" icon="pi pi-sign-in" type="submit" className="w-full tight-icon" />
            </form>
        </Card>
        {!apiErrorDialog && (
        <Dialog 
                header={errorHeader} 
                visible={errorDialogVisible} 
                style={{width: '25rem'}}
                onHide={hideDialog} 
                footer={
                    <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                }
            >    
             <p>

                    {errorMessage}
                </p>
            </Dialog>
        )}
    </div>
)
}

export default LoginPage;